var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-flag 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    id: "Vector (Stroke)",
    d: "M2.74219 10.9688V2.4375C2.74219 2.15704 2.96954 1.92969 3.25 1.92969H9.34375C9.53894 1.92969 9.71681 2.04159 9.80138 2.21751C9.88593 2.39344 9.86221 2.60226 9.74028 2.75468L8.36899 4.46875L9.74028 6.18282C9.86221 6.33524 9.88593 6.54406 9.80138 6.71999C9.71681 6.89591 9.53894 7.00781 9.34375 7.00781H3.75781V10.9688C3.75781 11.2492 3.53046 11.4766 3.25 11.4766C2.96954 11.4766 2.74219 11.2492 2.74219 10.9688ZM3.75781 5.99219H8.28726L7.32222 4.78593C7.17388 4.60048 7.17388 4.33702 7.32222 4.15157L8.28726 2.94531H3.75781V5.99219Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.674cc6098486c77109bf0e21855a3d57.svg";
export { ForwardRef as ReactComponent };